import React from "react";
import "./Homepage.css";
import { Typography, AspectRatio, Grid, Stack } from "@mui/joy";
import Illustration from "../../bill-card-illustration.png";

const Stats = () => {
  return (
    <Stack direction={'column'} padding={8} spacing={4}>
      <Stack direction={'column'} spacing={1}>
        <Typography level="h1" style={{ textAlign: "center" }}>
          Empowerment Through Information
        </Typography>
        <Typography level="body-lg" style={{ textAlign: "center" }}>
          Get the latest on upcoming legislation and advocate for what you
          believe in!
        </Typography>
      </Stack>
      <Stack spacing={6} direction={{xs: "column", md: "row"}}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
              <Typography
                level="h1"
                color="primary"
                sx={{ textAlign: "center", width: "100%", fontSize: "56px" }}
              >
                10,000+
              </Typography>
              <Typography
                level="title-sm"
                sx={{ textAlign: "center", width: "100%" }}
              >
                Bills introduced
              </Typography>
              <Typography
                level="body-sm"
                sx={{ textAlign: "center", width: "100%" }}
              >
                Over 10,000 bills are introduced in Congress each year.
              </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
              <Typography
                level="h1"
                color="primary"
                sx={{ textAlign: "center", width: "100%", fontSize: "56px" }}
              >
                20%
              </Typography>
              <Typography
                level="title-sm"
                sx={{ textAlign: "center", width: "100%" }}
              >
                Influence on legislation
              </Typography>
              <Typography
                level="body-sm"
                sx={{ textAlign: "center", width: "100%" }}
              >
                Email campaigns show a substantial influence, up to 20%, on
                legislative voting behavior.
              </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
              <Typography
                level="h1"
                color="primary"
                sx={{ textAlign: "center", width: "100%", fontSize: "56px" }}
              >
                1/3
              </Typography>
              <Typography
                level="title-sm"
                sx={{ textAlign: "center", width: "100%" }}
              >
                Know their representative
              </Typography>
              <Typography
                level="body-sm"
                sx={{ textAlign: "center", width: "100%" }}
              >
                Only 1/3 of Americans know their Representative's name.
              </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
              <Typography
                level="h1"
                color="primary"
                sx={{ textAlign: "center", width: "100%", fontSize: "56px" }}
              >
                29%
              </Typography>
              <Typography
                level="title-sm"
                sx={{ textAlign: "center", width: "100%" }}
              >
                Approval of Congress
              </Typography>
              <Typography
                level="body-sm"
                sx={{ textAlign: "center", width: "100%" }}
              >
                Only 29% of Americans currently approve of the way Congress is
                handling its job.
              </Typography>
          </Grid>
        </Grid>
        <AspectRatio
          ratio="670 / 332"
          objectFit="contain"
          flex={true}
          color="transparent"
          sx={{
            overflow: "auto",
            flexBasis: {sm: 'auto', md: 2500},
          }}
        >
          <img alt="" src={Illustration} />
        </AspectRatio>
      </Stack>
    </Stack>
  );
};

export default Stats;
